import Big from 'big.js'

export const Games = [
  {
    title: 'gg_pg',
    type: 0,
    tabs: [
      {
        id: 39,
        label: 'PG',
        name_en: 'Piggy Gold',
        name_pt: 'Piggy Gold',
      },
      {
        id: 40,
        label: 'PG',
        name_en: 'Jungle Delight',
        name_pt: 'Jungle Delight',
      },
      {
        id: 42,
        label: 'PG',
        name_en: 'Ganesha Gold',
        name_pt: 'Ganesha Gold',
      },
      {
        id: 71,
        label: 'PG',
        name_en: 'Caishen Wins',
        name_pt: 'Caishen Wins',
      },
      {
        id: 48,
        label: 'PG',
        name_en: 'Double Fortune',
        name_pt: 'Double Fortune',
      },
      {
        id: 53,
        label: 'PG',
        name_en: 'The Great Icescape',
        name_pt: 'The Great Icescape',
      },

      {
        id: 54,
        label: 'PG',
        name_en: "Captain's Bounty",
        name_pt: "Captain's Bounty",
      },
      {
        id: 84,
        label: 'PG',
        name_en: 'Queen of Bounty',
        name_pt: 'Queen of Bounty',
      },
      {
        id: 57,
        label: 'PG',
        name_en: 'Dragon Hatch',
        name_pt: 'Dragon Hatch',
      },
      {
        id: 58,
        label: 'PG',
        name_en: "Vampire's Charm",
        name_pt: "Vampire's Charm",
      },
      {
        id: 60,
        label: 'PG',
        name_en: 'Leprechaun Riches',
        name_pt: 'Leprechaun Riches',
      },
      {
        id: 62,
        label: 'PG',
        name_en: 'Gem Saviour Conquest',
        name_pt: 'Gem Saviour Conquest',
      },
      {
        id: 65,
        label: 'PG',
        name_en: 'Mahjong Ways',
        name_pt: 'Mahjong Ways',
      },
      {
        id: 68,
        label: 'PG',
        name_en: 'Fortune Mouse',
        name_pt: 'Fortune Mouse',
      },
      {
        id: 69,
        label: 'PG',
        name_en: 'Bikini Paradise',
        name_pt: 'Bikini Paradise',
      },
      {
        id: 74,
        label: 'PG',
        name_en: 'Mahjong Ways 2',
        name_pt: 'Mahjong Ways 2',
      },
      {
        id: 75,
        label: 'PG',
        name_en: 'Ganesha Fortune',
        name_pt: 'Ganesha Fortune',
      },
      {
        id: 79,
        label: 'PG',
        name_en: 'Dreams Of Macau',
        name_pt: 'Dreams Of Macau',
      },

      {
        id: 82,
        label: 'PG',
        name_en: 'Phoenix Rises',
        name_pt: 'Phoenix Rises',
      },
      {
        id: 83,
        label: 'PG',
        name_en: 'Wild Fireworks',
        name_pt: 'Wild Fireworks',
      },
      {
        id: 85,
        label: 'PG',
        name_en: "Genie's 3 Wishes",
        name_pt: "Genie's 3 Wishes",
      },
      {
        id: 86,
        label: 'PG',
        name_en: 'Galactic Gems',
        name_pt: 'Galactic Gems',
      },
      {
        id: 87,
        label: 'PG',
        name_en: 'Treasures of Aztec',
        name_pt: 'Treasures of Aztec',
      },
      {
        id: 88,
        label: 'PG',
        name_en: 'Jewels Of Prosperity',
        name_pt: 'Jewels Of Prosperity',
      },

      {
        id: 90,
        label: 'PG',
        name_en: 'Secrets of Cleopatra',
        name_pt: 'Secrets of Cleopatra',
      },
      {
        id: 1615454,
        label: 'PG',
        name_en: "Werewolf's Hunt",
        name_pt: "Werewolf's Hunt",
      },
      {
        id: 1451122,
        label: 'PG',
        name_en: 'Dragon Hatch 2',
        name_pt: 'Dragon Hatch 2',
      },
      {
        id: 1695365,
        label: 'PG',
        name_en: 'Fortune Dragon',
        name_pt: 'Fortune Dragon',
      },
      {
        id: 1671262,
        label: 'PG',
        name_en: 'Gemstones Gold',
        name_pt: 'Gemstones Gold',
      },
      {
        id: 1368367,
        label: 'PG',
        name_en: 'Alchemy Gold',
        name_pt: 'Alchemy Gold',
      },

      {
        id: 1372643,
        label: 'PG',
        name_en: 'Diner Delights',
        name_pt: 'Diner Delights',
      },
      {
        id: 1340277,
        label: 'PG',
        name_en: 'Asgardian Rising',
        name_pt: 'Asgardian Rising',
      },
      {
        id: 1402846,
        label: 'PG',
        name_en: 'Midas Fortune',
        name_pt: 'Midas Fortune',
      },
      {
        id: 113,
        label: 'PG',
        name_en: "Raider Jane's Crypt of Fortune",
        name_pt: "Raider Jane's Crypt of Fortune",
      },
      {
        id: 114,
        label: 'PG',
        name_en: 'Emoji Riches',
        name_pt: 'Emoji Riches',
      },
      {
        id: 115,
        label: 'PG',
        name_en: 'Supermarket Spree',
        name_pt: 'Supermarket Spree',
      },

      {
        id: 117,
        label: 'PG',
        name_en: 'Cocktail Nights',
        name_pt: 'Cocktail Nights',
      },
      {
        id: 1338274,
        label: 'PG',
        name_en: 'Totem Wonders',
        name_pt: 'Totem Wonders',
      },
      {
        id: 1543462,
        label: 'PG',
        name_en: 'Fortune Rabbit',
        name_pt: 'Fortune Rabbit',
      },
      {
        id: 1418544,
        label: 'PG',
        name_en: 'Bakery Bonanza',
        name_pt: 'Bakery Bonanza',
      },
      {
        id: 1420892,
        label: 'PG',
        name_en: 'Rave Party Fever',
        name_pt: 'Rave Party Fever',
      },
      {
        id: 1432733,
        label: 'PG',
        name_en: 'Mystical Spirits',
        name_pt: 'Mystical Spirits',
      },

      {
        id: 1448762,
        label: 'PG',
        name_en: 'Songkran Splash',
        name_pt: 'Songkran Splash',
      },
      {
        id: 1381200,
        label: 'PG',
        name_en: 'Hawaiian Tiki',
        name_pt: 'Hawaiian Tiki',
      },
      {
        id: 1513328,
        label: 'PG',
        name_en: 'Super Golf Drive',
        name_pt: 'Super Golf Drive',
      },
      {
        id: 1397455,
        label: 'PG',
        name_en: 'Fruity Candy',
        name_pt: 'Fruity Candy',
      },
      {
        id: 1473388,
        label: 'PG',
        name_en: 'Cruise Royale',
        name_pt: 'Cruise Royale',
      },

      {
        id: 1594259,
        label: 'PG',
        name_en: 'Safari Wilds',
        name_pt: 'Safari Wilds',
      },
      {
        id: 1572362,
        label: 'PG',
        name_en: "Gladiator's Glory",
        name_pt: "Gladiator's Glory",
      },
      {
        id: 1529867,
        label: 'PG',
        name_en: 'Ninja Raccoon Frenzy',
        name_pt: 'Ninja Raccoon Frenzy',
      },
      {
        id: 1489936,
        label: 'PG',
        name_en: 'Ultimate Striker',
        name_pt: 'Ultimate Striker',
      },
      {
        id: 1568554,
        label: 'PG',
        name_en: 'Wild Heist Cashout',
        name_pt: 'Wild Heist Cashout',
      },
      {
        id: 1555350,
        label: 'PG',
        name_en: 'Forge of Wealth',
        name_pt: 'Forge of Wealth',
      },

      {
        id: 1580541,
        label: 'PG',
        name_en: 'Mafia Mayhem',
        name_pt: 'Mafia Mayhem',
      },
      {
        id: 1655268,
        label: 'PG',
        name_en: 'Tsar Treasures',
        name_pt: 'Tsar Treasures',
      },
      {
        id: 118,
        label: 'PG',
        name_en: 'Mask Carnival',
        name_pt: 'Mask Carnival',
      },
      {
        id: 119,
        label: 'PG',
        name_en: 'Spirited Wonders',
        name_pt: 'Spirited Wonders',
      },
      {
        id: 120,
        label: 'PG',
        name_en: "The Queen's Banquet",
        name_pt: "The Queen's Banquet",
      },
      {
        id: 121,
        label: 'PG',
        name_en: 'Destiny of Sun & Moon',
        name_pt: 'Destiny of Sun & Moon',
      },

      {
        id: 122,
        label: 'PG',
        name_en: 'Garuda Gems',
        name_pt: 'Garuda Gems',
      },
      {
        id: 123,
        label: 'PG',
        name_en: 'Rooster Rumble',
        name_pt: 'Rooster Rumble',
      },
      {
        id: 124,
        label: 'PG',
        name_en: 'Battleground Royale',
        name_pt: 'Battleground Royale',
      },
      {
        id: 125,
        label: 'PG',
        name_en: 'Butterfly Blossom',
        name_pt: 'Butterfly Blossom',
      },
      {
        id: 126,
        label: 'PG',
        name_en: 'Fortune Tiger',
        name_pt: 'Fortune Tiger',
      },
      {
        id: 127,
        label: 'PG',
        name_en: 'Speed Winner',
        name_pt: 'Speed Winner',
      },

      {
        id: 128,
        label: 'PG',
        name_en: 'Legend of Perseus',
        name_pt: 'Legend of Perseus',
      },
      {
        id: 129,
        label: 'PG',
        name_en: 'Win Win Fish Prawn Crab',
        name_pt: 'Win Win Fish Prawn Crab',
      },
      {
        id: 130,
        label: 'PG',
        name_en: 'Lucky Piggy',
        name_pt: 'Lucky Piggy',
      },
      {
        id: 132,
        label: 'PG',
        name_en: 'Wild Coaster',
        name_pt: 'Wild Coaster',
      },
      {
        id: 135,
        label: 'PG',
        name_en: 'Wild Bounty Showdown',
        name_pt: 'Wild Bounty Showdown',
      },
      {
        id: 1312883,
        label: 'PG',
        name_en: 'Prosperity Fortune Tree',
        name_pt: 'Prosperity Fortune Tree',
      },

      {
        id: 91,
        label: 'PG',
        name_en: 'Guardians of Ice & Fire',
        name_pt: 'Guardians of Ice & Fire',
      },
      {
        id: 92,
        label: 'PG',
        name_en: 'Thai River Wonders',
        name_pt: 'Thai River Wonders',
      },
      {
        id: 93,
        label: 'PG',
        name_en: 'Opera Dynasty',
        name_pt: 'Opera Dynasty',
      },
      {
        id: 94,
        label: 'PG',
        name_en: 'Bali Vacation',
        name_pt: 'Bali Vacation',
      },
      {
        id: 95,
        label: 'PG',
        name_en: 'Majestic Treasures',
        name_pt: 'Majestic Treasures',
      },
      {
        id: 97,
        label: 'PG',
        name_en: "Jack Frost's Winter",
        name_pt: "Jack Frost's Winter",
      },

      {
        id: 98,
        label: 'PG',
        name_en: 'Fortune Ox',
        name_pt: 'Fortune Ox',
      },
      {
        id: 100,
        label: 'PG',
        name_en: 'Candy Bonanza',
        name_pt: 'Candy Bonanza',
      },
      {
        id: 101,
        label: 'PG',
        name_en: 'Rise Of Apollo',
        name_pt: 'Rise Of Apollo',
      },
      {
        id: 102,
        label: 'PG',
        name_en: 'Mermaid Riches',
        name_pt: 'Mermaid Riches',
      },
      {
        id: 103,
        label: 'PG',
        name_en: 'Crypto Gold',
        name_pt: 'Crypto Gold',
      },
      {
        id: 104,
        label: 'PG',
        name_en: 'Wild Bandito',
        name_pt: 'Wild Bandito',
      },

      {
        id: 105,
        label: 'PG',
        name_en: 'Heist Stakes',
        name_pt: 'Heist Stakes',
      },
      {
        id: 106,
        label: 'PG',
        name_en: 'Ways of the Qilin',
        name_pt: 'Ways of the Qilin',
      },
      {
        id: 107,
        label: 'PG',
        name_en: 'Legendary Monkey King',
        name_pt: 'Legendary Monkey King',
      },
      {
        id: 108,
        label: 'PG',
        name_en: 'Buffalo Win',
        name_pt: 'Buffalo Win',
      },
      {
        id: 110,
        label: 'PG',
        name_en: 'Jurassic Kingdom',
        name_pt: 'Jurassic Kingdom',
      },
      {
        id: 112,
        label: 'PG',
        name_en: 'Oriental Prosperity',
        name_pt: 'Oriental Prosperity',
      },
    ],
  },
  {
    title: 'gg_quente',
    type: 1,
    tabs: [
      {
        id: 98,
        label: 'PG',
        name_en: 'Fortune Ox',
        name_pt: 'Fortune Ox',
      },
      {
        id: 100,
        label: 'PG',
        name_en: 'Candy Bonanza',
        name_pt: 'Candy Bonanza',
      },
      {
        id: 101,
        label: 'PG',
        name_en: 'Rise Of Apollo',
        name_pt: 'Rise Of Apollo',
      },
      {
        id: 102,
        label: 'PG',
        name_en: 'Mermaid Riches',
        name_pt: 'Mermaid Riches',
      },
      {
        id: 103,
        label: 'PG',
        name_en: 'Crypto Gold',
        name_pt: 'Crypto Gold',
      },
      {
        id: 104,
        label: 'PG',
        name_en: 'Wild Bandito',
        name_pt: 'Wild Bandito',
      },
    ],
  },
]

export const getGameName = (id, language = 'pt') => {
  const obj = Games[0].tabs.find((item) => item.id == id)
  return obj?.[`name_${language}`]
}

// 减法 处理小数计算浮点问题
export const subtractDecimals = (num1, num2) => {
  const bigNum1 = new Big(num1)
  const bigNum2 = new Big(num2)
  const result = bigNum1.minus(bigNum2)
  return result.toString()
}
